export default __webpack_public_path__ + "static/media/photo--sm--kickoff3b.e55c7f29.jpg";